import { Grid, Space } from "../Layout";
import { Texts, Title, Media, Button } from "../Object";

const Choose = (props) => {
  const listGroup = 'choose-list';
  
  return (
    <>
      <Space size={["120px 0 0", "72px 0 0"]}>
        <div className="l-row">
          <Title slug="choose"></Title>

          <Space size={["100px auto 0", "64px auto 0"]}>
            <List group={listGroup} />
          </Space>
        </div>
      </Space>
    </>
  );
};


export const List = (props) => {
  const Item = (props) => {
    const gridProps = {
      item: {
        dir: ["column", "row"],
        layout: ["510px 1fr", "100%"],
        gap: ["80px", "40px"],
      },
    };

    return (
      <>
        <li className="item">
          <div className="p-title__wrap--section">
            <Texts slug={`${props.group}/list-title${props.index}`}></Texts>
          </div>

          <Space size={["56px 0 0", "40px 0 0"]}>
            <Grid {...gridProps.item}>
              <Texts slug={`${props.group}/list-body${props.index}`}></Texts>
              <Media
                src={`${props.group}/list${props.index}`}
                alt="media"
              ></Media>
            </Grid>
          </Space>
        </li>
      </>
    );
  };

  const length = props.length ? props.length : 3;
  let items = [];
  for (let i = 0; i < length; i++) {
    items.push(<Item key={i} index={i} group={props.group}></Item>);
  }

  const gridProps = {
    list: {
      dir: "row",
      layout: "100%",
      size: "100%",
      gap: ["100px", "72px"],
    },
  };
  return (
    <>
      <ul className="list">
        <Grid {...gridProps.list}>{items}</Grid>
      </ul>
    </>
  );
};

export default Choose;
